import { render, staticRenderFns } from "./PlatformConfigureProgram.vue?vue&type=template&id=73556f56&scoped=true"
import script from "./PlatformConfigureProgram.vue?vue&type=script&lang=js"
export * from "./PlatformConfigureProgram.vue?vue&type=script&lang=js"
import style0 from "./PlatformConfigureProgram.vue?vue&type=style&index=0&id=73556f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73556f56",
  null
  
)

export default component.exports